import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";
import "./ChairmanMessage.css";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const directorQuote = "“If you want to shine like the sun, first burn like the sun.\" – Dr. A.P.J. Abdul Kalam";

const directorMessageParagraphs = [
  "At TIMSCDR, we believe in building foundation on a wide base of knowledge which includes the elements of professional, subjective, practical and spiritual base. We believe that in today’s competitive and fast changing environment, it is time of complete knowledge. In our academic program , we are sworn to excellence. It is a passion shared equally by the institute’s faculty, students, corporate sponsors and alumni. Transcending effectively the ever changing business horizon is the key challenge for today’s IT professionals. It is our consistent endeavor at TIMSCDR to identity the evolving leadership / managerial imperatives of industry and pursue a multidisciplinary approach to harness & channelise the latent potential of our budding IT professionals accordingly.",
  "We consistently focus on experiential learning and thoughtful consideration on how to develop business leaders with a sense of commitment to work quality and sense of drive in life that can effectively motivate and coordinate team based approach in challenging business environment. To this end, we ensure a conducive environment where in budding professionals unlock their entire human asset potential and develop their inherent skills and insight to facilitate them to do the leadership roles in their own right."
];

function Director() {
 const [showForm, setShowForm] = useState(false);

  return (
    <div className="chairman-page director">
      <Navbar setShowForm={setShowForm} />
   {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <PageHeader
        title="Director's Message"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Director's Message" },
        ]}
      />

      <main className="chairman-message-wrap">
        <section className="chairman-message-card" aria-labelledby="director-message-title">
          <aside className="chairman-profile">
            <img src="/images/MCA00233.JPG" alt="Dr. Pravin Gundalwar" />
            <div className="chairman-profile-caption">
              <h2 id="director-message-title">Dr. Pravin Gundalwar</h2>
              <p>Director</p>
              <span aria-hidden="true" />
            </div>
          </aside>

          <article className="chairman-copy">
            <span className="chairman-quote-mark" aria-hidden="true">
              &ldquo;
            </span>
            
            {/* Renders the quote block with intentional emphasis */}
            <p><strong>{directorQuote}</strong></p>
            
            {/* Renders remaining body content paragraphs safely */}
            {directorMessageParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            <div className="chairman-signature">
              <strong>Dr. Pravin Gundalwar</strong>
              <span>Director, TIMSCDR</span>
            </div>
          </article>
        </section>
      </main>

      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </div>
  );
}

export default Director;